import { render, staticRenderFns } from "./General.vue?vue&type=template&id=65172ffe&scoped=true&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"
import style0 from "./General.vue?vue&type=style&index=0&id=65172ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65172ffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65172ffe')) {
      api.createRecord('65172ffe', component.options)
    } else {
      api.reload('65172ffe', component.options)
    }
    module.hot.accept("./General.vue?vue&type=template&id=65172ffe&scoped=true&", function () {
      api.rerender('65172ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/SettingRenew/Contents/General.vue"
export default component.exports